import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import Error404 from '../../components/Error/Error404'
import { useParams } from 'react-router-dom'
import { Container, Row, Col, Nav, Table } from "react-bootstrap";
import Collapsible from 'react-collapsible';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import PageTitle from '../../components/pageTitle/pageTitle.component';

// import ExamsPageCover from '../../assets/images/banners/exams.png';
import CoverImage from '../../assets/images/publications/cover-1.png';

import './examDetailsPage.css';
import ExamHeader from '../../components/examHeader/examHeader.component';

const ExamDetailsPage = props => {

    const { examId } = useParams()

    const { loading, publications, webExam } = useSelector(state => state.all)

    const [exam, setExam] = useState()

    useEffect(() => {
        setExam(webExam.find(item => item._id === examId))
    }, [webExam, examId])

    useEffect(() => {

        if (exam) {
            if (exam.overview) {
                document.getElementById('exam-overview').innerHTML = exam.overview
            }
            exam.modules.map((item, index) => {
                document.getElementById(`description${index}`).innerHTML = item.description
            })
        }
    }, [exam])

    return (
        loading ? <Loading /> : exam ? <>
            <ExamHeader
                title={exam.title}
                cover={`${bucket_url}${exam.coverPhoto}`}
                price={exam.price}
                discount={exam.discount}
            >
                <p>
                    {exam.excerpt}
                </p>
            </ExamHeader>

            <section className="course-nav-section">
                <Container>
                    <Row>
                        <Col xs={12} lg={6}>
                            <Nav className="courses-nav" defaultActiveKey="#overview" as="ul">
                                <Nav.Item as="li">
                                    <Nav.Link href="#overview">Overview</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link href="#course-module">Exam Module</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                    <Nav.Link href="#faq-section">FAQ</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section id="overview" className="py-5">
                <Container>
                    <Row>
                        <Col>
                            <div id='exam-overview'>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {exam && exam.modules.length > 0 && <section id="course-module" className="course-module-section pb-2">
                <PageTitle
                    variant="light"
                    title="ই-এক্সাম মডিউল"
                // subTitle="ব্লগ সম্পর্কে এইখানে কিছু লিখা যাবে, ব্লগ সম্পর্কে এইখানে কিছু লিখা যাবে,
                //          ব্লগ সম্পর্কে এইখানে কিছু লিখা যাবে"
                />
                <Container>
                    <Row className="mb-5">
                        <Col>
                            {exam.modules.map((item, index) => (

                                <Collapsible trigger={`${index + 1}.${item.title}`}>
                                    <div id={`description${index}`}>
                                        {/* {item.description} */}
                                    </div>
                                </Collapsible>
                            ))}
                        </Col>
                    </Row>
                </Container>
            </section>}
            {exam && exam.faqs.length > 0 && <section id="faq-section" className="faq-section pb-2">
                <Container>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <h3 className="faq-sec-title text-center">বহুল জিজ্ঞাসিত প্রশ্নসমূহ</h3>
                        </Col>
                    </Row>
                    {loading ? <Loading /> : (
                        <Row className="mb-5">
                            <Col>
                                {exam.faqs.map((item, index) => (

                                    <Collapsible trigger={`${index + 1}.${item.question}`}>
                                        <p>
                                            {item.answer}
                                        </p>
                                    </Collapsible>
                                ))}
                            </Col>
                        </Row>
                    )}
                </Container>
            </section>}
            <section className="related-publication-section pb-5">
                <PageTitle
                    variant="light"
                    title="সম্পর্কিত প্রকাশনাসমূহ"
                />
                <Container>
                    <Row>
                        {publications && publications.map((item, index) => {
                            if (index < 4) {
                                return <Col xs={12} md={4} lg={3}>
                                    <PublicationCard item={item} />
                                </Col>
                            }
                        })}
                    </Row>
                </Container>
            </section>
        </> : <Error404 />
    )
}

export default ExamDetailsPage;